import Button from '../UI/Button';
import BioContext from '../../store/bio-context';
import ThemeContext from '../../store/theme-context';
import React, { useContext } from "react";
import Projects from "../Projects/Projects";
import { useNavigate } from "react-router-dom";

const ProjectSection = () => {
    const navigate = useNavigate();
    const profileData = useContext(BioContext);
    const theme = useContext(ThemeContext);
    const projects = profileData.Projects;
    let topThreeProjects = [];

    for (let j = projects.length-1; j>=0 && j > projects.length-4; j--){
        topThreeProjects.push(projects[j]);
    }
    return ( 
        <section style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}> 
        {topThreeProjects && <h2 className="sectionHeading">PROJECTS</h2>}
        {topThreeProjects.length > 0 && 
        <div>
            <Projects projects={topThreeProjects}/>
            <div className="viewMore">
            <Button className="btn-viewMore" onClick={()=>navigate('/projects')} buttonTitle="VIEW ALL"/>
            </div>
        </div>
        }
        {!topThreeProjects.length === 0 && <h3>Nothing to show!</h3>}
        <div>
        </div>
        </section>
     );
}
 
export default ProjectSection;